import Checkbox from "@mui/material/Checkbox";
import { styled } from "@mui/material/styles";

// Styled MUI Checkbox with custom color and margin
const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  color: "#76B041",
  '&.Mui-checked': {
    color: "#76B041",
  },
  marginLeft: theme.spacing(1.5),
}));

export default StyledCheckbox;
